import { ClarionButton } from '@clarion/ClarionButton';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import { Assignment, formatTimeSpent } from '../../assignments/assignment';
import AssignmentForm from '../../assignments/AssignmentForm';
import { useActiveTimerQuery } from '../../assignments/useActiveTimer';
import { useTimer } from '../../assignments/useTimer';
import { useUserState } from '../../auth/UserState';
import { useSideNavigation } from './SideNavigationContext';

export function ActiveTimerButton() {
  const { user } = useUserState();
  const { isCollapsed } = useSideNavigation();
  const { data: activeTimerData, refetch: refetchActiveTimer } = useActiveTimerQuery();
  const [modalAssignment, setModalAssignment] = useState<Assignment | null>(null);
  const navigate = useNavigate();

  const activeAssignment = activeTimerData?.assignment || null;
  const { elapsedTime, isTimerRunning } = useTimer(activeAssignment, user?.uid || '');

  const handleCloseModal = () => {
    setModalAssignment(null);
    refetchActiveTimer();
  };

  const handleJumpToFile = () => {
    if (!activeAssignment) return;
    navigate(`/workspaces/${activeAssignment.workspaceId}/files/${activeAssignment.fileId}`);
    setModalAssignment(null);
  };

  const displayTimer = activeAssignment && user?.uid && isTimerRunning;
  const formattedTime = formatTimeSpent(elapsedTime);

  return (
    <>
      {displayTimer && (
        <ClarionButton
          variant={isTimerRunning ? 'outlined' : 'minimal'}
          intent={isTimerRunning ? 'primary' : 'none'}
          onClick={() => setModalAssignment(activeAssignment)}
          tooltip={`Currently tracking: ${activeAssignment.title} - ${formattedTime}`}
          tooltipPlacement="right"
          icon="time"
          fill
          textAlign="left"
          size={isCollapsed ? 'large' : 'medium'}
        >
          {!isCollapsed && (
            <div className="min-w-0 flex-1 pl-2">
              <div className="text-xs opacity-75">Currently tracking</div>
              <div className="font-medium truncate">{activeAssignment.title}</div>
              <div className="text-xs">{formattedTime}</div>
            </div>
          )}
        </ClarionButton>
      )}

      {modalAssignment && (
        <AssignmentForm
          isOpen
          onClose={handleCloseModal}
          onAssignmentUpdated={() => refetchActiveTimer()}
          onAssignmentDeleted={handleCloseModal}
          existingAssignment={modalAssignment}
          extraActions={
            <ClarionButton icon="document-open" intent="primary" onClick={handleJumpToFile}>
              Jump to File
            </ClarionButton>
          }
        />
      )}
    </>
  );
}
